module.exports = __webpack_public_path__ + "assets/img/ljlq.48c167f8.png";